import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.configure-sso', {
        url: '/configure-sso',
        component: 'companyManageApplicationIntegrationDevelopersConfigureSso',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/configure-sso/configure-sso.state.js